module.exports = __webpack_public_path__ + "img/neuro-surgery.784bc028.png";